<template>
  <!--
    	作者：luoyiming
    	时间：2019-10-26
    	描述：商品管理-商品编辑-规格/库存-多规格-表格
    -->
  <div class="mt16">
    <el-form-item label="规格明细：" class="labelStyle"
                  v-if="form.model.specMany && form.model.specMany.specList.length > 0">
      <div>
        批量设置
        <!--        <el-input size="small" v-model="batchData.productPrice" placeholder="销售价"-->
        <!--                  style="width: 160px;padding-left: 4px;"></el-input>-->
        <!--        <el-input size="small" v-model="batchData.presellPrice" placeholder="预售价"-->
        <!--                  style="width: 160px;padding-left: 4px;"></el-input>-->
        <!--        <el-input size="small" v-model="batchData.linePrice" placeholder="划线价"-->
        <!--                  style="width: 160px;padding-left: 4px;"></el-input>-->
        <el-input size="small" v-model="batchData.stockNum" placeholder="库存"
                  style="width: 160px;padding-left: 4px;"></el-input>
        <el-input size="small" v-model="batchData.productWeight" placeholder="重量"
                  style="width: 160px;padding-left: 4px;"></el-input>
        <el-select size="small" v-model="batchData.deliveryId" style="width: 160px;padding-left: 4px;"
                   placeholder="运费模版">
          <el-option v-for="item in form.delivery" :value="item.deliveryId" :key="item.deliveryId"
                     :label="item.name"></el-option>
        </el-select>
        <el-input size="small" v-model="batchData.manufactureDate" placeholder="生产日期"
                  style="width: 160px;padding-left: 4px;"></el-input>
        <el-input size="small" v-model="batchData.expiryDate" placeholder="保质期"
                  style="width: 160px;padding-left: 4px;"></el-input>
        <el-button size="small" @click="onSubmitBatchData">应用</el-button>
        <el-button size="small" @click="batchChooseimage">批量传图</el-button>
      </div>
      <!--多规格表格-->
      <div>
        <el-table size="mini" :data="form.model.specMany.specList" :span-method="objectSpanMethod" border
                  style="width: 100%; margin-top: 10px">
          <el-table-column :label="item.groupName" :key="item.groupName"
                           v-for="(item, index) in form.model.specMany.specAttr">
            <template slot-scope="scope">
              {{ scope.row.rows[index].specValue }}
            </template>
          </el-table-column>
          <el-table-column label="规格图片">
            <template slot-scope="scope">
              <img v-img-url="scope.row.specForm.imagePath" alt="" width="35" height="35"
                   @click="chooseSpecImage(scope.$index)"/>
            </template>
          </el-table-column>
          <el-table-column label="商家编码">
            <template slot-scope="scope">
              <el-form-item label="" style="margin-bottom: 0;">
                <el-input size="small" prop="productNo" v-model="scope.row.specForm.productNo"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="规格码">
            <template slot-scope="scope">
              <el-form-item label="" style="margin-bottom: 0;">
                <el-input size="small" prop="productNo" v-model="scope.row.specForm.specNo"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="运费模版">
            <template slot-scope="scope">
              <el-form-item label="" :rules="[{type:'number', required: true, message: '' }]" style="margin-bottom: 0;"
                            :prop="'model.specMany.specList.' + scope.$index + '.specForm.deliveryId'">
                <!--                <el-input size="small" prop="productNo" v-model="scope.row.specForm.specNo"></el-input>-->
                <el-select v-model="scope.row.specForm.deliveryId" style="width: 100%">
                  <el-option v-for="item in form.delivery" :value="item.deliveryId" :key="item.deliveryId"
                             :label="item.name"></el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="供货价格(元)" v-if="position===1">
            <template slot-scope="scope">
              <el-form-item label="" :rules="[{ required: true, message: '' }] " style="margin-bottom: 0;"
                            :prop="'model.specMany.specList.' + scope.$index + '.specForm.supplierPrice'">
                <el-input v-money size="small" v-model="scope.row.specForm.supplierPrice"></el-input>

              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="佣金(元)" v-if="position===2">
            <template slot-scope="scope">
              <el-form-item label="" style="margin-bottom: 0;"
                            :prop="'model.specMany.specList.' + scope.$index + '.specForm.commissionPrice'">
                <el-input size="small" v-model="scope.row.specForm.commissionPrice"></el-input>

              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="平台留存(元)" v-if="position===2">
            <template slot-scope="scope">
              <el-form-item label="" style="margin-bottom: 0;"
                            :prop="'model.specMany.specList.' + scope.$index + '.specForm.platRetentionPrice'">
                <el-input size="small" v-model="scope.row.specForm.platRetentionPrice"></el-input>

              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="销售价(元)" v-if="position===2">
            <template slot-scope="scope">
              <el-form-item
                label=""
                :rules="[{ required: true, message: ' ' }]"
                :prop="'model.specMany.specList.' + scope.$index + '.specForm.productPrice'"
                style="margin-bottom: 0;"
              >
                <el-input size="small" prop="productPrice" readonly
                          :value="getProductPrice(scope.row)"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <!--          <el-table-column label="预售价(元)" v-if="position===2">-->
          <!--            <template slot-scope="scope">-->
          <!--              <el-form-item label="" style="margin-bottom: 0;" :rules="[{ required:true, message: ' ' }]"-->
          <!--                            :prop="'model.specMany.specList.' + scope.$index + '.specForm.presellPrice'">-->
          <!--                <el-input size="small" prop="presellPrice" v-model="scope.row.specForm.presellPrice"></el-input>-->
          <!--              </el-form-item>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <el-table-column label="建议销售价(元)">
            <template slot-scope="scope">
              <el-form-item label="" style="margin-bottom: 0;">
                <el-input v-money size="small" prop="linePrice" v-model="scope.row.specForm.referencePrice"></el-input>
              </el-form-item>
              <div v-show="false">{{ getProductPrice(scope.row) }}</div>
            </template>
          </el-table-column>

          <el-table-column label="划线价(元)" v-if="position===2">
            <template slot-scope="scope">
              <el-form-item label="" style="margin-bottom: 0;">
                <el-input size="small" prop="linePrice" v-model="scope.row.specForm.linePrice"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="库存" v-if="position===1">
            <template slot-scope="scope">
              <el-form-item
                label=""
                :rules="[{ required: true, message: ' ' }]"
                :prop="'model.specMany.specList.' + scope.$index + '.specForm.stockNum'"
                style="margin-bottom: 0;"
              >
                <el-input size="small" type="number" prop="stockNum" v-model="scope.row.specForm.stockNum"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="重量(kg)" v-if="position===1">
            <template slot-scope="scope">
              <el-form-item
                label=""
                :rules="[{ required: true, message: ' ' }]"
                :prop="'model.specMany.specList.' + scope.$index + '.specForm.productWeight'"
                style="margin-bottom: 0;"
              >
                <el-input size="small" type="number" prop="productWeight"
                          v-model="scope.row.specForm.productWeight"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="生产日期">
            <template slot-scope="scope">
              <el-form-item
                label=""
                :prop="'model.specMany.specList.' + scope.$index + '.specForm.manufactureDate'"
                style="margin-bottom: 0;"
              >
                <el-input size="small" prop="manufactureDate"
                          v-model="scope.row.specForm.manufactureDate"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="保质期">
            <template slot-scope="scope">
              <el-form-item
                label=""
                :prop="'model.specMany.specList.' + scope.$index + '.specForm.expiryDate'"
                style="margin-bottom: 0;"
              >
                <el-input size="small" prop="expiryDate"
                          v-model="scope.row.specForm.expiryDate"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="最低限购数量">
            <template slot-scope="scope">
              <el-form-item
                label=""
                :rules="[{pattern:/^[1-9]{1}[0-9]*$/, required: true, message: ' ' }]"
                :prop="'model.specMany.specList.' + scope.$index + '.specForm.minLimit'"
                style="margin-bottom: 0;"
              >
                <el-input size="small" type="number" min="1" prop="minLimit"
                          v-model="scope.row.specForm.minLimit"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-form-item>
    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
  </div>
</template>

<script>
import Upload from '@/components/file/Upload'

export default {
  components: {
    Upload
  },
  props: {
    position: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      /*批量设置sku属性*/
      batchData: {
        // productPrice: '',
        // supplierPrice: 0,
        // commissionPrice: 0,
        // platRetentionPrice: 0,
        // linePrice: '',
        stockNum: '',
        productWeight: '',
        deliveryId: '',
        minLimit: 1,
        manufactureDate: '',
        expiryDate: ''
      },
      /*图片是否打开*/
      isupload: false,
      //上传图片选择的下标
      specIndex: -1,
      imageType: 'single'
    }
  },
  inject: ['form'],
  created () {

  },
  methods: {
    getProductPrice (row) {
      let productPrice = 0
      if (row.specForm.supplierPrice) {
        productPrice += parseFloat(row.specForm.supplierPrice)
      }
      if (this.form.model.isEnableCommission === 1) {
        if (row.specForm.commissionPrice) {
          productPrice += parseFloat(row.specForm.commissionPrice)
        }
        if (row.specForm.platRetentionPrice) {
          productPrice += parseFloat(row.specForm.platRetentionPrice)
        }
      }
      row.specForm.productPrice = productPrice ? productPrice.toFixed(2) : 0 || 0
      return row.specForm.productPrice
    },
    /*表格跨行*/
    objectSpanMethod ({row, column, rowIndex, columnIndex}) {
      var specAttr = this.form.model.specMany.specAttr
      // 规格组合总数 (table行数)
      var totalRow = 1
      //比如2个规格,只有第一列有多行
      if (columnIndex < specAttr.length - 1) {
        let startRowIndex = columnIndex + 1
        let endRowIndex = specAttr.length - 1
        for (var i = startRowIndex; i <= endRowIndex; i++) {
          totalRow *= specAttr[i].specItems.length
        }
        if (rowIndex % totalRow === 0) {
          return {
            rowspan: totalRow,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },

    /*批量设置sku属性*/
    onSubmitBatchData: function () {
      var self = this
      self.form.model.specMany.specList.forEach(function (value) {
        for (var key in self.batchData) {
          if (self.batchData.hasOwnProperty(key) && self.batchData[key]) {
            self.$set(value.specForm, key, self.batchData[key])
          }
        }
      })
    },

    /*选择图片*/
    chooseSpecImage: function (specIndex) {
      this.isupload = true
      this.imageType = 'single'
      this.specIndex = specIndex
    },

    batchChooseimage () {
      this.isupload = true
      this.imageType = 'batch'
    },

    /*返回图片*/
    returnImgsFunc (e) {
      this.isupload = false
      let _self = this
      if (this.imageType === 'single') {
        this.$set(this.form.model.specMany.specList[this.specIndex].specForm, 'imageId', e[0]['fileId'])
        this.$set(this.form.model.specMany.specList[this.specIndex].specForm, 'imagePath', e[0]['filePath'])
      } else if (this.imageType === 'batch') {
        if (this.form.model.specMany.specList && this.form.model.specMany.specList.length) {
          this.form.model.specMany.specList.forEach((item, index) => {
            console.log(index)
            _self.$set(_self.form.model.specMany.specList[index].specForm, 'imageId', e[0]['fileId'])
            _self.$set(_self.form.model.specMany.specList[index].specForm, 'imagePath', e[0]['filePath'])
          })
        }
      }
    }
  }
}
</script>

<style lang="css" scoped>
.labelStyle >>> .el-form-item__label {
  font-size: 16px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/product/product/part/spec/many/Table.vue